class UserNotificationCtrl {
  constructor($timeout, $rootScope, $sce, EventService) {
    'ngInject';
    Object.assign(this, { $timeout, $rootScope, $sce });
    this.es = EventService;
    this.messages = [];
    this.messageContent = '';
  }

  async $onInit() {
    this.setColumns();
    this.loadMessages();
    this.setMessage(this.messageId);
  }

  setColumns() {
    this.messageColumns = [
      {
        'key': 'title',
        'header': 'Title',
        'sortable': true,
        'onClick': (_, message) => this.setMessage(message.id)
      }
    ];
  }

  setMessage(messageId) {
    const msg = this.messages.find(n => n.id === messageId) || { title: 'User Message List', message: '' };
    this.messageId = messageId;
    this.title = msg.title;
    this.messageContent = this.$sce.trustAsHtml((msg.message || '').toString());
  }

  loadMessages() {
    this.messages = (this.$rootScope["userMessages"]?.list || []).filter(m => m.type != 'Banner');
  }
}

export default {
  bindings: {
    messageId: "<",
    cancelModal: "&"
  },
  templateUrl: 'form-builder/user-notification/user-notification.component.html',
  controller: UserNotificationCtrl
};
